'use strict';
const Api_Ids = {
    FORM_SEARCH_API_ID: 1,
    USER_SEARCH_API_ID: 2
};
export {
    Api_Ids
}


// WEBPACK FOOTER //
// ./client/components/constants/api.connection.constants.ts